import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import Vision from "components/Vision";

import Pricing from "components/Pricing";
import InterviewQA from "components/InterviewQA";
import Home from "components/Home";

import Drawer from "components/Drawer";
import Create from "components/Create";
import AboutUs from "components/AboutUs";
import JobSearch from "components/JobSearch";
import JobResults from "components/JobResults";
import Insight from "components/Insight";
import Logout from "components/Logout";
import Test from "components/Test";
import AOS from "aos";
import { isMobile } from "react-device-detect";
import SideNav from "components/Drawer";

import "antd/dist/reset.css";
import "aos/dist/aos.css";
import "./fonts.css";

class App extends Component {
  componentDidMount() {
    setTimeout(() => {
      AOS.init({
        offset: isMobile ? 10 : 100,
      });
      AOS.refresh();
    }, 1500);
  }

  render() {

    const userId = localStorage.getItem("tal_id");
    return (
      <>
        <Router hashType="noslash" basename={process.env.BASE_PATH}>
          <Switch>
            <Route exact path="/Links">
              <div>
                pxCode Screen List: <br />
                <Link to="/Vision">Vision</Link>
                <br />
                <Link to="/Pricing">Pricing</Link>
                <br />
                <Link to="/InterviewQA">InterviewQA</Link>
                <br />
                <Link to="/Home">Home</Link>
                <br />
                <Link to="/Create">Create</Link>
                <br />
                <Link to="/AboutUs">AboutUs</Link>
              </div>
            </Route>

            <Route exact path="/JobSearch" component={JobSearch} />
            <Route exact path="/JobResults" component={JobResults} />
            <Route exact path="/Insight" component={Insight} />
            <Route exact path="/Pricing" component={Pricing} />
            <Route exact path="/Interview/:userId" component={InterviewQA} />
            <Route exact path="/Interview" component={InterviewQA} />
            <Route exact path="/Home" component={Home} />

            <Route exact path="/Drawer" component={Drawer} />
            <Route exact path="/Create" component={Create} />
            <Route exact path="/AboutUs" component={AboutUs} />
            <Route exact path="/Logout" component={Logout} />
            <Route exact path="/Test" component={Test} />
            <Route exact path="/" component={Home} />
          </Switch>
          <SideNav
            subdomains={[
              { title: "Getting Started", subdomain: "/" },
              // { title: "Ask", subdomain: "/" },
              { title: "AI Interview", subdomain: `/Interview/${userId}` },              
              { title: "Profile", subdomain: "/Create" },
              { title: "Insights", subdomain: "/Insight" },
              { title: "Plans", subdomain: "/Pricing" },
              { title: "About Us", subdomain: "/AboutUs" },
              { title: "Job Search", subdomain: "/JobSearch" },              
              { title: "Logout", subdomain: "/Logout" },
            ]}
          />
        </Router>
      </>
    );
  }
}

export default App;
